import CSSTransition from "react-transition-group/CSSTransition";

import classes from "./ModalState.module.css";
import Ok from "../../assets/form-ok.png";
import Error from "../../assets/form-error.png";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useAppDispatch } from "../../store/hooks";
import { UIActions } from "../../store/ui-slice";

const ModalState = () => {
  const { isShown, isError, status, message: uiMessage } = useSelector((state: RootState) => state.ui);

  const modalClasses = `${classes.modal} ${!isError ? classes.ok : ""}`;
  
  const dispatch = useAppDispatch();
  const nodeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let uiStatusTimeout: ReturnType<typeof setTimeout>;
    if(isShown) {
      uiStatusTimeout = setTimeout(() => {
        dispatch(UIActions.hide());
      }, 3000);
    }

    return () => {
      clearTimeout(uiStatusTimeout);
    }
    // status restarts the clock when "Loading..." turns into the result, so a
    // slow save doesn't eat into the time the confirmation stays up.
  }, [isShown, status, dispatch]);

  return (
    <CSSTransition
      in={isShown}
      timeout={250}
      mountOnEnter
      unmountOnExit
      nodeRef={nodeRef}
      onExited={() => dispatch(UIActions.unset())}
      classNames={{
          enterActive: classes.show,
          exitActive: classes.hide
      }}
    >
    <div className={modalClasses} ref={nodeRef}>
      <div className={classes.icon}>
        <img
          src={!isError ? Ok: Error}
          className="img-responsive"
          alt=""
          width="18"
          height="15"
        />
      </div>
      <div className={classes.text}>{uiMessage}</div>
    </div>
    </CSSTransition>
  );
};

export default ModalState;
